import { ElementDefinition } from '@/runtime/shared/elements-definition';
import defaultHtml from './stories/default.story.html?raw';

import { menuPropsDocs, menuItemPropsDocs } from './menu.types';

/**
 * Docs definition for the Card component and its custom elements.
 *
 * Used by the docs site to render:
 * - API tables for `<e-menu>`
 * - Example stories in the code playground
 */
export const definition: ElementDefinition = {
  componentName: 'Menu',
  elements: [
    {
      tag: 'e-menu',
      description: 'Container of the menu',
      props: Object.values(menuPropsDocs)
    },
    {
      tag: 'e-menu-item',
      description: 'Item of the menu',
      props: Object.values(menuItemPropsDocs)
    }
  ],

  stories: [
    {
      id: 'default',
      name: 'Default',
      description: 'A default menu',
      html: defaultHtml
    }
  ]
};
